import React from 'react';
import { Redirect } from 'react-router-dom';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { Formik, Form } from 'formik';
import { connect } from 'react-redux';
import Button from 'shared/components/button/Button';
import PasswordField from 'shared/components/password-field/PasswordField';
import { changePasswordSchema } from 'utils/validators/changePassword';
import { WRONG_PASSWORD, TOO_MANY_REQUESTS } from 'utils/constants/errors';
import { changePassword } from '../ducks/settingsActions';
import { CLEAR_STATE } from '../ducks/types';

const ChangePassword = props => {
  if (props.passwordUpdated) {
    props.clearState();
    props.toggle();
    return <Redirect to="/settings" />;
  }
  return (
    <Modal isOpen={props.isOpen} className="password-modal">
      <ModalHeader>
        <span>Change Password</span>
        <span className="modal-close action" onClick={props.toggle}>
          Close
        </span>
      </ModalHeader>
      <ModalBody>
        <Formik
          initialValues={{
            currentPassword: '',
            newPassword: '',
            confirmPassword: ''
          }}
          validationSchema={changePasswordSchema}
          onSubmit={(values, { setFieldError }) => {
            return props
              .updatePassword(values.currentPassword, values.newPassword)
              .catch(err => {
                if (err.code === WRONG_PASSWORD) {
                  return setFieldError(
                    'currentPassword',
                    'The current password is incorrect'
                  );
                } else if (err.code === TOO_MANY_REQUESTS) {
                  return setFieldError(
                    'currentPassword',
                    'Too many attemps. Try again later.'
                  );
                }
              });
          }}
        >
          {({ isSubmitting, values, errors }) => (
            <Form>
              <div className="form-content">
                <PasswordField
                  label="Current Password"
                  name="currentPassword"
                />
                <PasswordField label="New Password" name="newPassword" />
                <PasswordField
                  label="Confirm Password"
                  name="confirmPassword"
                />
                <div className="form-check">
                  <label
                    className={`form-check-label ${
                      values['newPassword'].length === 0 ||
                      errors['newPassword']
                        ? ''
                        : 'active'
                    }`}
                  >
                    <i className="fas fa-check-square"></i>
                    <span>At least 6 characters long</span>
                  </label>
                </div>
                <div className="form-action">
                  <Button
                    id=""
                    type="submit"
                    btnBlock="block"
                    color="primary"
                    label="Change Password"
                    disabled={isSubmitting}
                  />
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </ModalBody>
    </Modal>
  );
};

function mapStateToProps(state) {
  return {
    passwordUpdated: state.settingsReducer.passwordUpdated,
    passwordUpdateError: state.settingsReducer.passwordUpdateError
  };
}

function mapDispatchToProps(dispatch) {
  return {
    updatePassword: (currentPassword, newPassword) =>
      dispatch(changePassword(currentPassword, newPassword)),
    clearState: () => dispatch({ type: CLEAR_STATE })
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChangePassword);
